// project imports
import config from 'config';

// action - state management
import * as actionTypes from './actions';
const savedCustomTheme = JSON.parse(localStorage.getItem('customTheme'));
export const initialState = {
    isOpen: [], // for active default menu
    defaultId: 'default',
    fontFamily: config.fontFamily,
    borderRadius: config.borderRadius,
    opened: true,
    color: 'green',
    themeName: localStorage.getItem('themeName') || 'orange',
    customTheme: savedCustomTheme || null
};

// ==============================|| CUSTOMIZATION REDUCER ||============================== //

const customizationReducer = (state = initialState, action) => {
    console.log('------action-------------', action);
    let id;
    switch (action.type) {
        case actionTypes.MENU_OPEN:
            id = action.id;
            return {
                ...state,
                isOpen: [id]
            };
        case actionTypes.SET_MENU:
            return {
                ...state,
                opened: action.opened
            };
        case actionTypes.SET_FONT_FAMILY:
            return {
                ...state,
                fontFamily: action.fontFamily
            };
        case actionTypes.SET_BORDER_RADIUS:
            return {
                ...state,
                borderRadius: action.borderRadius
            };
        case actionTypes.SET_THEME_COLOR:
            return {
                ...state,
                themeColor: action.themeColor
            };
        case actionTypes.SET_THEME_NAME:
            return {
                ...state,
                themeName: action.themeName
            };
        case actionTypes.SET_CUSTOM_THEME:
            return { ...state, customTheme: action.customTheme };
        default:
            return state;
    }
};

export default customizationReducer;
